
export const Config =
{
    use_fake_geo_location_provider: false,
    splash_screen_duration: 1500,
    host:"hypercity.ch",
    twitter_text: "hypercity–genevebm"
};